import { LoadingButton } from '@mui/lab'
import {
  Stack,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  TextField,
  Box,
} from '@mui/material'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  open: boolean
  onClose: () => void
  onConfirm: (value: string, isConfirmDialog: boolean) => void
  title?: string
  isLoading?: boolean
  isConfirmDialog: boolean
}

export const ConfirmationRejectionFormDialog = ({
  title,
  open,
  onClose,
  onConfirm,
  isLoading,
  isConfirmDialog,
}: Props) => {
  const { t } = useTranslation()
  const [value, setValue] = useState('')

  const handleClose = () => {
    onClose()
  }

  const handleConfirm = () => {
    onConfirm(value, isConfirmDialog)
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {title ?? t('confirmation-dialog')}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ padding: '15px 0' }}>
          <TextField
            sx={{ minWidth: 420 }}
            size="small"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            label={isConfirmDialog ? t('message') : t('reason')}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3 }}>
        <Stack
          width="100%"
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Button
            onClick={handleClose}
            variant="contained"
            style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
            color="error"
          >
            {t('close')}
          </Button>
          <LoadingButton
            loading={isLoading}
            onClick={handleConfirm}
            variant="contained"
            style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
            color="primary"
            autoFocus
          >
            {isConfirmDialog ? t('confirm') : t('reject')}
          </LoadingButton>
        </Stack>
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmationRejectionFormDialog
